var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader",class:{
		'preloader--bg': _vm.bg,
		'preloader--static': _vm.staticPosition
	},style:({ 'background-color': _vm.bgc })},[_c('lottie-player',{ref:"lottie",staticClass:"preloader__animation",attrs:{"background":"transparent","autoplay":"","loop":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }